"use client";
import Image from "next/image";
import React, { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import { ChevronLeft, ChevronRight } from "lucide-react";

import "swiper/css";
import "swiper/css/pagination";

const studentData = [
    {
        name: "Khushi Sarwaiya",
        role: "Kitchen Associate",
        companyLogo: "https://cdn.msu.edu.in/The_Oberoi.webp",
        image: "https://cdn.msu.edu.in/Khushi.png",
    },
    {
        name: "Sahil Sharma",
        role: "F&B & Event Service Expert",
        companyLogo: "https://cdn.msu.edu.in/le_meridian.webp",
        image: "https://cdn.msu.edu.in/Sahil_Sharma.png",
    },
    {
        name: "Biswajit Sahoo",
        role: "Commis II",
        companyLogo: "https://cdn.msu.edu.in/The-Fern.png",
        image: "https://cdn.msu.edu.in/Biswajit_Sahoo.png",
    },
    {
        name: "Monika Pahal",
        role: "F&B Associate",
        companyLogo: "https://cdn.msu.edu.in/cp-gold.webp",
        image: "https://cdn.msu.edu.in/monika.png",
    },
    {
        name: "Sourabh",
        role: "Associate",
        companyLogo: "https://cdn.msu.edu.in/Crowne_Plaza.png",
        image: "https://cdn.msu.edu.in/Sourabh.jpg",
    },
    {
        name: "Biswajit Rana",
        role: "Front Office Associate",
        companyLogo: "https://cdn.msu.edu.in/The-Fern.png",
        image: "https://cdn.msu.edu.in/Biswajit-Rana.jpg",
    },
];

const Placements = () => {
    const swiperRef = useRef(null);

    return (
        <section className="overflow-hidden bg-max-w-(--max-page-width) mx-auto px-(--container-padding) w-full py-16  bg-white">
            <div className="w-full mx-auto">

                <div className="text-center">
                    <p className="text-[#F5A400] uppercase tracking-[4px] text-xs font-semibold mb-4">
                        Placements
                    </p>

                    <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold">
                        Our Placements
                    </h2>

                    <p className="text-black/80 max-w-2xl mx-auto mt-4">
                        <span className="font-bold">98% {" "}</span>
                        Placement Success—Unlocking Careers with Industry’s Best Packages
                    </p>
                </div>

                <div className="relative mt-10" >
                    <Swiper
                        modules={[Autoplay, Pagination]}
                        loop
                        speed={500}
                        autoplay={{
                            delay: 2000,
                            disableOnInteraction: false,
                            pauseOnMouseEnter: true,
                        }}
                        pagination={{ clickable: true }}
                        onSwiper={(swiper) => {
                            swiperRef.current = swiper;
                        }}
                        slidesPerView={4}
                        slidesPerGroup={1}
                        breakpoints={{
                            0:   { slidesPerView: 1, slidesPerGroup: 1 },
                            640: { slidesPerView: 2, slidesPerGroup: 1 },
                            768: { slidesPerView: 2, slidesPerGroup: 1 },
                            1024: { slidesPerView: 4, slidesPerGroup: 1 },
                        }}
                        className="w-full pb-10"
                    >
                        {studentData.map((placement, index) => (
                            <SwiperSlide key={index}>
                                <div className="placement-card-wrap bg-white overflow-hidden flex flex-col justify-between px-2">
                                    <div className="overflow-hidden relative w-full">
                                        <div className="relative w-full h-100 sm:h-100 md:h-90 overflow-hidden">
                                            <Image
                                                src={placement.image}
                                                alt={placement.name}
                                                fill
                                                className="object-cover transition-transform duration-300 hover:scale-105"
                                            />
                                        </div>

                                        <div className="absolute bottom-0 left-0 w-full p-3 text-white bg-[linear-gradient(0deg,rgba(0,0,0,1)_0%,rgba(0,0,0,0.6)_50%,rgba(0,0,0,0)_100%)]">
                                            <h3 className="text-lg font-semibold">
                                                {placement.name}
                                            </h3>
                                            <p className="text-sm">{placement.role}</p>
                                        </div>
                                    </div>

                                    <div className="border border-[#FFA201] p-4 flex justify-center items-center h-25 w-full">
                                        <Image
                                            src={placement.companyLogo}
                                            alt={`${placement.name} company logo`}
                                            width={200}
                                            height={65}
                                            className="h-15 w-auto object-contain"
                                        />
                                    </div>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>

                    <button
                        type="button"
                        aria-label="Show previous placement"
                        onClick={() => swiperRef.current?.slidePrev()}
                        className="absolute left-2 top-1/2 z-20 flex h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full bg-white/95 text-black shadow-lg transition hover:bg-[#F5A400] disabled:cursor-not-allowed disabled:opacity-40 md:-left-5"
                    >
                        <ChevronLeft className="h-5 w-5" />
                    </button>
                    <button
                        type="button"
                        aria-label="Show next placement"
                        onClick={() => swiperRef.current?.slideNext()}
                        className="absolute right-2 top-1/2 z-20 flex h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full bg-white/95 text-black shadow-lg transition hover:bg-[#F5A400] disabled:cursor-not-allowed disabled:opacity-40 md:-right-5"
                    >
                        <ChevronRight className="h-5 w-5" />
                    </button>
                </div>

            </div>
        </section>
    );
}

export default Placements
